export default __webpack_public_path__ + "34b7dba067844c7e6ee9dd6dd5703ff1.png";